import { Button, Divider, Paper, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { DialogContext } from "../../contexts/DialogContext";

// updated v1
export default function ConfirmationDialog(props: {
    title: string;
    acceptText?: string;
    declineText?: string;
    onAccept: () => void;
}) {
    const { closeDialog } = useContext(DialogContext);

    const handleClose = () => {
        closeDialog();
    };

    const handleAccept = () => {
        props.onAccept();
        closeDialog();
    };

    return (
        <Paper sx={{ p: 2, maxWidth: 350 }}>
            <Typography color="text.secondary">{props.title}</Typography>

            <Divider sx={{ my: 2 }} />

            <Stack direction="row" spacing={2} justifyContent="space-between">
                <Button
                    variant="contained"
                    color="warning"
                    onClick={handleAccept}
                >
                    {props.acceptText ?? "تایید"}
                </Button>

                <Button
                    variant="outlined"
                    color="success"
                    onClick={handleClose}
                >
                    {props.declineText ?? "بازگشت"}
                </Button>
            </Stack>
        </Paper>
    );
}
